import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Grid, DatePicker, Typography, Flex, Radio,  Button, Drawer, Tooltip } from "antd";
import { useForm } from "antd/es/form/Form";
import InputField from "../../../../components/Input/Input";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import { QuestionCircleOutlined } from "@ant-design/icons";

import { fetchManufacturingNumber, fetchManufacturingRecord, } from "../manufacturingThunk";
import {
  setFormField,
  setEntryDate,
  setDueDate,
  setTaxMode,
  addOrderRow,
  calculateTotals,
  setTaxAcc,
  setDiscountAcc,
} from "../manufacturingSlice";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import { fetchItems, fetchTaxAccs, fetchDiscountAccs} from "../../../../store/commonThunks/lookups";
import { selectDiscountAccs, selectSuppliers, selectTaxAccs } from "../../../../store/commonSelectors/lookupsSelectors";
import StaticAutoComplete from "../../../../components/StaticAutoComplete";
import { formatToCompanyTimezone, getYearFromCompanyDate, pathSpliter } from "../../../../lib/functions";
import useMigrationDate from "../../../../hooks/useMigrationDate";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateManufacturingForm = ({ authInfo, mfId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = useForm();
  const screens = useBreakpoint();
  const location = useLocation();
  const [helpOpen, setHelpOpen] = React.useState(false);
  const { entryDate, narration, voucherNumber, taxMode, itemCart, selectedTaxAcc } =
    useSelector((s) => s.manufacturing); // ✅ include itemCart here

  useEffect(() => {
    dispatch(fetchItems());

    // dispatch(fetchTaxAccs()).then((res) => {      
    //   if (res.payload && res.payload.length > 0) {
    //     dispatch(setTaxAcc(res.payload[0])); // pick first as default
    //   }
    // }); 
    // dispatch(fetchDiscountAccs()).then((res) => {
    //   if (res.payload && res.payload.length > 0) {
    //     dispatch(setDiscountAcc(res.payload[0])); // pick first as default
    //   }
    // });     
  }, [dispatch]);

  useEffect(() => {
    const id = pathSpliter(location.pathname, 3) || 0;
    if (id) {
      dispatch(fetchManufacturingRecord(id));
    }
  }, [location, dispatch]);

  const handleFieldChange = (field, value) => {
    dispatch(setFormField({ field, value }));
  };
const {disabledDate}= useMigrationDate();
   useEffect(() => {
    if(mfId) {
      return;
    }
      let formatedDate = entryDate ? dayjs(entryDate).toISOString() : null;
      let companydate = formatToCompanyTimezone(formatedDate);
      const year = getYearFromCompanyDate(companydate);
    dispatch(fetchManufacturingNumber(year));
    }, [entryDate]);

  return (
    <div>
      <Flex justify="space-between" align="center">
        <Title level={3} >
          Manufacturing
        </Title>

        <Tooltip title="Help">
          <Button
            type="text"
            icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
            onClick={() => setHelpOpen(true)}
          />
        </Tooltip>
      </Flex>
      <Form form={form}
        layout="horizontal"
        style={{ width: "100%", maxWidth: "1200px" }}
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}>
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          // justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          {/* <Flex
        vertical
        gap={10}
        style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
      >
        
          <Form.Item label="Search Supplier">
            <SearchListAutoComplete
              entityType="supplier"
              placeholder="Supplier"
              optionsList={(suppliers || []).map((s) => ({
                sale_id: s.acc_id,
                display_text: s.acc_name || s.institution_name,
                raw: s,
              }))}
              onSelect={(obj) => handleSupplierSelect(obj?.raw)}
              showAddNew={true}
            />
          </Form.Item>

          <Form.Item label="Search Invoice/Voucher" required>
            <SearchListAutoComplete
              placeholder="Select Invoice/Voucher"
              style={{ width: "100%" }}
              optionsList={(invoiceList || []).map((inv) => ({
                sale_id: inv.pur_id,
                display_text: inv.label,
                raw: inv,
              }))}
              onSelect={(obj) => {
              if (!obj?.raw) return;
              dispatch(setSelectedInvoice(obj.raw));

              // If editing existing return (url contains id) -> fetch record
              const id = parseFloat(pathSpliter(location.pathname, 3)) || 0;
              if (id) {
                dispatch(fetchManufacturingRecord(id));
              } else {
                // Otherwise (new return) -> fetch purchase invoice items
                dispatch(fetchInvoiceItemsForReturn(obj.raw.pur_id));
              }

              // clear cart before refill
              dispatch(setFormField({ field: "itemCart", value: [] }));
            }}
              showAddNew={false}
            />
          </Form.Item>



          <Form.Item label="Institution Name">
            <InputField value={supplierInfo?.institution_name || ""} disabled />
          </Form.Item>
          <Form.Item label="Supplier Address">
            <InputField value={supplierInfo?.address || ""} disabled />
          </Form.Item>
          <Form.Item label="Contact No">
            <InputField value={supplierInfo?.contact_no || ""} disabled />
          </Form.Item>
        </Flex> */}

          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item label="Voucher No.">
              <InputField value={voucherNumber} disabled data-testid="manufacturing-no" />
            </Form.Item>

            <Form.Item label="Entry Date">
              <DatePicker
                value={entryDate ? dayjs(entryDate) : null}
                onChange={(d) => dispatch(setEntryDate(d))}
                style={{ width: "100%" }}
                format="DD-MM-YYYY"   // <--- formatting handled here
                 disabledDate={disabledDate}
              />
            </Form.Item>

          </Flex>
        </Flex>
      </Form>
      <Drawer
        title="Manufacturing Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "8px",
            }}
          >
            Manufacturing Entry
          </h2>

          <p
            style={{
              color: "#555",
              marginBottom: "16px",
              marginLeft: "8px",
            }}
          >
            The Manufacturing module is used to record and manage production
            activities within the ERP system. It helps track raw materials,
            finished goods, and manufacturing-related inventory movements
            accurately.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Steps to Create Manufacturing Entry</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>Open <strong>Manufacturing</strong></li>
              <li>Verify voucher number and entry date</li>
              <li>Select raw materials or input items</li>
              <li>Add finished goods/output items</li>
              <li>Verify quantity and production details</li>
              <li>Review inventory impact and totals</li>
              <li>Click <strong>Save</strong> to complete the manufacturing entry</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Manufacturing entries affect inventory stock automatically.</li>
              <li>Verify raw material and finished goods quantities carefully.</li>
              <li>Voucher numbers are generated automatically.</li>
              <li>Saved manufacturing entries can be edited later if required.</li>
            </ul>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default CreateManufacturingForm;
